// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:d1067655-776c-4804-a50d-cb3154a6fc99",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_S5dC81J7H",
    "aws_user_pools_web_client_id": "7tb4veirrq0h6b1h877dugedt2",
    "oauth": {}
};


export default awsmobile;
